import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "yugo_admin_token";

export const ALL_SECTIONS = [
    "dashboard", "live", "rides", "customers", "drivers",
    "earnings", "fare-rules", "promo-codes", "tickets", "team",
];

export const SECTION_LABELS = {
    dashboard: "Dashboard",
    live: "Live Rides",
    rides: "All Rides",
    customers: "Customers",
    drivers: "Drivers",
    earnings: "Earnings",
    "fare-rules": "Fare Rules",
    "promo-codes": "Promo Codes",
    tickets: "Support / Tickets",
    team: "Team Members",
};

export const userCan = (user, section) => {
    if (!user) return false;
    if (user.role === "super_admin") return true;
    const perms = user.permissions || [];
    return perms.includes("*") || perms.includes(section);
};

export const api = axios.create({
    baseURL: API_BASE,
    headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            const path = window.location.pathname;
            if (path !== "/login") {
                localStorage.removeItem(TOKEN_KEY);
                window.location.href = "/login";
            }
        }
        return Promise.reject(error);
    }
);

export const formatApiErrorDetail = (detail) => {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
};

export const formatCurrency = (n) => {
    if (n === null || n === undefined) return "—";
    return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0,
    }).format(n);
};

export const formatDateTime = (s) => {
    if (!s) return "—";
    try {
        const d = new Date(s);
        return d.toLocaleString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    } catch {
        return s;
    }
};

export const formatDate = (s) => {
    if (!s) return "—";
    try {
        const d = new Date(s);
        return d.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    } catch {
        return s;
    }
};

export const downloadAuthenticated = async (path, filename) => {
    const token = localStorage.getItem(TOKEN_KEY);
    const res = await fetch(`${API_BASE}${path}`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) throw new Error(`Download failed: ${res.status}`);
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};

export const fileUrl = (fileApiPath) => {
    if (!fileApiPath) return "";
    const token = localStorage.getItem(TOKEN_KEY);
    return `${BACKEND_URL}${fileApiPath}?auth=${encodeURIComponent(token || "")}`;
};
